/*eslint-disable */
const DEV = "dev";

const STAGE = "stage";

const PRODUCTION = "production";

const ENVS = {
    DEV, STAGE, PRODUCTION
}

export default ENVS;